// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyAHiu7pYfaudvbn78MzkPZ7RaWXhoU31mw",
  authDomain: "fkpokp.firebaseapp.com",
  projectId: "fkpokp",
  storageBucket: "fkpokp.firebasestorage.app",
  messagingSenderId: "179971202688",
  appId: "1:179971202688:web:d0d6acf500626c2b439065",
  measurementId: "G-2HTEMEHEPV"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };